<template>
  <div>
    <v-form autocomplete = "off" lazy-validation ref="form" v-model="valid">
      <v-container class="tab-header the-main-concept">
        <h1>{{ $t('edit_profile') }}</h1>
      </v-container>
      <v-layout class="ex-my-account">
        <v-container class="account-container">
          <v-layout class="account-content" row wrap v-if="userData"
                    align-content-space-around
                    align-content-space-between
                    justify-space-between
          >
            <v-flex class="d-flex justify-flex-start align-center ex-flex-col" md2 sm12  xs12>
              <div class ="avatar-img" v-if="avatarImg === ''" >
                <img :alt="$t('avatar')" src="../../../assets/images/NoImage.png" />
              </div>
              <div class ="avatar-img" v-else >
                <img :alt="$t('avatar')" :src="avatarImg" />
              </div>
              <v-btn :ripple="false" @click="tiggerInputFile" class="image-upload-btn" flat >{{ $t('replace_photo') }}</v-btn>
              <v-btn :ripple="false" @click.native="openRequestModal" class="image-upload-btn" flat>{{ $t('account_info') }}</v-btn>
              <v-btn v-if="roles.includes('user')" :ripple="false" @click.native="openDeleteModal" class="image-upload-btn" flat> {{$t('accounts.delete_your_account')}}</v-btn>
              <input :data-buttonText="$t('avatar')" :multiple="false" class="ex-edit-account d-none" ref="file" type="file" v-on:change="onFileChange(userData.image,$event)">
            </v-flex>
            <v-flex class="input-case1" md4 sm6 xs12>
              <div class="input-sect">
                <label class="ex-flat-label">{{ $t('first_name') }}</label>
                <v-text-field
                  :counter="15"
                  :rules="firstNameRules"
                  class="inner-input ex-input-group one"
                  flat
                  required
                  solo
                  v-model="userData.firstName"
                />
              </div>
              <div class="input-sect">
                <label class="ex-flat-label">{{ $t('last_name') }}</label>
                <v-text-field
                  :counter="15"
                  :rules="lastNameRules"
                  class="inner-input ex-input-group"
                  color='indigo accent-4'
                  flat
                  required
                  solo
                  v-model="userData.lastName"
                />
              </div>
              <div class="input-sect">
                <label class="ex-flat-label">{{ $t('email') }}</label>
                <v-text-field
                  :rules="emailRules"
                  class="inner-input"
                  color='indigo accent-4'
                  flat
                  required
                  solo
                  v-model="userData.email"
                />
              </div>
              <div class="input-sect">
                <label class="ex-flat-label">{{ $t('phone_number') }}</label>
                <v-text-field
                  :rules="phoneNumberRules"
                  class="inner-input"
                  color='indigo accent-4'
                  flat
                  onblur="this.setAttribute('readonly', true)"
                  onclick="this.removeAttribute('readonly')"
                  placeholder="+374XXXXXXXX"
                  readonly
                  solo
                  v-model="userData.phoneNumber"
                />
              </div>
              <div class="input-sect">
                <label class="ex-flat-label">{{ $t('date_of_birth') }}</label>
                <v-text-field
                  :max="new Date().toISOString().substr(0, 10)"
                  :rules="dateBirthdayRules"
                  class="inner-input"
                  flat
                  solo
                  type="date"
                  v-model="userData.dateBirthday"
                />
              </div>
            </v-flex>

            <v-flex class="input-case2" md4 sm6 xs12>
              <div class="about-sect">
                <label class="ex-flat-label">{{ $t('about_me') }}</label>
                <v-textarea :counter="150"
                            :rules="aboutRules"
                            class="textarea-field"
                            color = 'indigo accent-4'
                            flat
                            no-resize
                            solo
                            v-model="userData.about"
                />
              </div >
              <div class="resp-change-pass w-100" v-if="stateUserData.googleId === null && stateUserData.facebookId  === null">
                <v-btn
                  :ripple = "false"
                  @click="hidden = !hidden"
                  class="password-change-btn"
                  flat
                  rotate
                >
                  <span>{{ $t('settings.change_password') }}</span>
                  <v-icon :class="{'rotate-180': hidden}">icon-angle-down-18</v-icon>
                </v-btn>
                <v-expand-transition transition="fade-transition">
                  <div class="fade-sect" transition="fade-transition" v-if="hidden">
                    <div class="input-sect">
                      <label class="ex-flat-label">{{ $t('old_password') }}</label>
                      <v-text-field
                        :rules="oldPassRules"
                        class="inner-input-password"
                        color='indigo accent-4'
                        flat
                        solo
                        type="password"
                        v-model="userData.oldPass"
                      />
                    </div>
                    <div class="input-sect">
                      <label class="ex-flat-label">{{ $t('new_password') }}</label>
                      <v-text-field
                        :rules="newPassRules"
                        class="inner-input-password"
                        color='indigo accent-4'
                        flat
                        solo
                        type="password"
                        v-model="userData.newPass"
                      />
                    </div>
                    <div class="input-sect">
                      <label class="ex-flat-label">{{ $t('confirm_password') }}</label>
                      <v-text-field
                        :rules="newPassConfRules"
                        class="inner-input-password"
                        color='indigo accent-4'
                        flat
                        solo
                        type="password"
                        v-model="userData.newPassConf"
                      />
                    </div>
                  </div>
                </v-expand-transition>
              </div>
            </v-flex>
          </v-layout>
          <v-card-actions  class="card-action" row wrap>
            <div class="buttons">
              <router-link :to="/accounts/ + userData.id">
                <v-btn :ripple="false"
                       class="g-btn-account-cancel"
                       flat
                >{{ $t('accounts.cancel') }}</v-btn>
              </router-link>
              <v-btn :disabled="!valid"
                     :ripple="false"
                     @click="updateUser()"
                     class="g-btn-account-save"
                     flat
              >{{ $t('save') }}</v-btn>
            </div>
          </v-card-actions>
        </v-container>
      </v-layout>
      <v-dialog
        persistent
        v-if="avatarImgCropSrc"
        v-model="avatarImgCropSrc"
        width="500px"
      >
        <v-card class="cropper-style-sect">
          <v-card-text>
            <vue-cropper
              :alt="$t('products.image')"
              :aspectRatio="1"
              :autoCropArea="0"
              :movable="false"
              :rotatable="false"
              :scalable="false"
              :src="avatarImgCropSrc"
              :viewMode="1"
              class="resp-cropper-sect"
              dragMode="move"
              ref="cropperAvatarImg"
              style="max-height: 500px"
              :zoomable="false"
            >
            </vue-cropper>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="cropper-btn-sect">
            <v-btn :ripple="false" @click="cancelCropAvatarImg" class="cancel-crop-btn" flat>{{$t('products.cancel')}}</v-btn>
            <v-btn :ripple="false" @click="cropAvatarImg" class="accept-crop-btn" flat>{{$t('products.crop_image')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <v-dialog max-width="550px" v-model="dialog">
      <v-form class="disable-form-contact" lazy-validation ref="form" v-model="valid">
        <v-card-title
          class="justify-center ex-card-title">
          <v-layout class="g-cancel-btn">
            <v-btn
              :ripple="false"
              @click.native="closeModal"
              class="ex-v-btn ex-close-btn">
              <i class="icon-cancel"></i>
            </v-btn>
          </v-layout>
          <p class="g-modal">{{ $t('contact_info') }}</p>
        </v-card-title>
        <v-card-title class="mt-5">
          <div class="call-button-container mt-3">
            <v-radio-group v-model="userData.visibility">
              <v-radio
                :label="$t('all_friends')"
                :value="1"
                class="ex-radio-button"
                color="blue"
                dark
              >
              </v-radio>
              <v-radio
                :label="$t('all_users')"
                :value="2"
                class="ex-radio-button"
                color="blue"
                dark
              />
              <v-radio
                :label="$t('hide_from_everyone')"
                :value="3"
                class="ex-radio-button"
                color="blue"
                dark
              />
            </v-radio-group>
            <p @click="openFriendsListModal"
               class="ex-radio-button-friend mb-5 cursor-pointer">
              <i class="material-icons" style="font-size: 30px!important">dehaze</i>
              <span class="mt-1">{{$t('friend_list')}}</span> </p>
          </div>

        </v-card-title>
        <v-container fluid>
          <v-card-actions class="modal-btn-sect">
            <v-btn :ripple="false" @click.native="closeModal" class="cancel-request-btn2">{{$t('products.cancel')}}</v-btn>
            <v-btn  :ripple="false" @click.native="accountVisibility" class="send-request-btn">{{$t('send')}}</v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-dialog>

    <v-dialog max-width="550px" v-model="dialogFriends">
      <v-form class="disable-form-contact" lazy-validation ref="form" v-model="valid">
        <v-card-title
          class="justify-center ex-card-title">
          <v-layout class="g-cancel-btn">
            <v-btn
              :ripple="false"
              @click.native="closeModalFriend"
              class="ex-v-btn ex-close-btn">
              <i class="icon-cancel"></i>
            </v-btn>
          </v-layout>
          <p class="g-modal">{{ $t('friend_list') }}</p>
        </v-card-title>

        <v-card-title>
          <div :key="index" class="layout mt-2 cursor-pointer ml-2" style="text-align: center; color:black"
               v-for="(friend,index) in allFriends">
            <v-list-tile-avatar class="avatar-image">
              <img :alt="$t('avatar')" :src="apiUrl+ friend.Friend.image" v-if="isLogged && friend.Friend.image"/>
              <img :alt="$t('avatar')" src="../../../../src/assets/images/NoImage.png" v-else/>
            </v-list-tile-avatar>
            <span class="mt-2">
              {{friend.Friend.firstName}}
              {{friend.Friend.lastName}}
              {{friend.Friend.email}}
            </span>
            <v-icon @click="individualFriend(friend)"
                    flat
                    v-bind:style="friend.showDetails === 1 ? 'color: green' : 'color: grey'"
            >check_circle
            </v-icon>
          </div>
        </v-card-title>
        <v-container fluid>
          <v-card-actions class="modal-btn-sect">
          </v-card-actions>
        </v-container>
      </v-form>
    </v-dialog>
    <v-dialog max-width="550px" v-model="dialogDelete">
      <v-form class="disable-form-contact" lazy-validation>
        <v-card-title
          class="justify-center ex-card-title">
          <v-layout class="g-cancel-btn">
            <v-btn
              :ripple="false"
              @click.native="closeDeleteModal"
              class="ex-v-btn ex-close-btn">
              <i class="icon-cancel"></i>
            </v-btn>
          </v-layout>
          <p class="g-modal">{{ $t('accounts.delete_info') }}</p>
        </v-card-title>
        <v-container fluid>
          <v-card-actions class="modal-btn-sect">
            <v-btn :ripple="false" @click.native="closeModal" class="cancel-request-btn2">{{$t('products.cancel')}}</v-btn>
            <v-btn  :ripple="false" @click.native="deleteAccount" class="send-request-btn">{{$t('accounts.delete')}}</v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import _ from 'lodash'
import VueCropper from 'vue-cropperjs'
import { validateEmail } from '../../../helpers/main'
import VueJwtDecode from 'vue-jwt-decode'
function decodeJwtToken () {
  let token = localStorage.getItem('token')
  if (token) {
    return VueJwtDecode.decode(token).permissions
  }
  return []
}
export default {
  name: 'MyCompanyAccount',
  props: [],
  components: {
    VueCropper: VueCropper
  },
  data: () => ({
    dialogDelete: false,
    isLogged: true,
    allFriends: [],
    visible: false,
    visibleAll: false,
    dialog: false,
    dialogFriends: false,
    active: null,
    requestDisabled: false,
    userData: {},
    valid: true,
    hidden: false,
    file: '',
    apiUrl: process.env.ROOT_API,
    avatarImg: '',
    avatarImgCropSrc: '',
    croppedAvatar: {}
  }),
  computed: {
    roles: () => decodeJwtToken(),
    ...mapState({
      stateUserData: state => state.auth.userData,
      friends: state => state.profile.userData.friends
    }),
    firstNameRules () {
      return [
        v => (!/[\d`~!@#$%^&*()_|+\-=?;:'",.<>[\]\\]/.test(v)) || this.$t('first_name_rule'),
        v => (!!v && v.trim() !== '') || this.$t('first_name_required'),
        v => (v && v.length <= 15) || this.$t('first_name_not_valid')
      ]
    },
    lastNameRules () {
      return [
        v => (!/[\d`~!@#$%^&*()_|+\-=?;:'",.<>[\]\\]/.test(v)) || this.$t('last_name_rule'),
        v => (!!v && v.trim() !== '') || this.$t('last_name_required'),
        v => (v && v.length <= 15) || this.$t('last_name_not_valid')
      ]
    },
    emailRules () {
      return [
        v => !!v || this.$t('email_required'),
        v => validateEmail(v) || this.$t('email_not_valid')
      ]
    },
    phoneNumberRules () {
      return [
        v => (!v || /^\+?(?:[0-9] ?){7,14}[0-9]$/.test(v)) || this.$t('phone_not_valid')
      ]
    },
    oldPassRules () {
      return [
        v => (!v || v.length >= 4) || this.$t('old_pass_not_valid')
      ]
    },
    newPassRules () {
      return [
        v => (!v || (this.userData.oldPass && this.userData.oldPass.length > 0)) || this.$t('old_pass_required'),
        v => ((/^(?=.*[a-z]).+$/.test(v) &&
          /^(?=.*[A-Z]).+$/.test(v) &&
          /^(?=.*[\d]).+$/.test(v) &&
          /([-+=_!@#$%^&*.,;:'"<>/?`~[\]\\\s])/.test(v) &&
          /^.{8,}/.test(v)) || this.$t('pass_rules'))
      ]
    },
    newPassConfRules () {
      return [
        v => (!v || (this.userData.newPass && v === this.userData.newPass)) || this.$t('conf_pass_not_valid')
      ]
    },
    aboutRules () {
      return [
        v => (!v || v.length <= 150) || this.$t('about_not_valid')
      ]
    },
    dateBirthdayRules () {
      return [
        v => (!v || new Date(v) <= new Date()) || this.$t('date_of_birth_not_valid')
      ]
    }
  },
  methods: {
    deleteAccount () {
      let userData = {
        id: this.userData.id
      }
      this.$store.dispatch('accounts/deleteAccount', userData).then((res) => {
        if (res && res.type === 'success') {
          this.$store.dispatch('auth/signOut')
          this.$store.dispatch('profile/clearUserData')
          this.$store.dispatch('profile/clearCategories')
          this.$router.push('/')
        }
      }).catch(console.error)
    },
    openDeleteModal () {
      this.dialogDelete = true
    },
    individualFriend (friend) {
      let data = {
        friendId: friend.Friend.id,
        userId: this.userData.id
      }
      this.$store.dispatch('accounts/individualFriend', data).then((res) => {
        if (res) {
          this.$store.commit('auth/setUserData', res.user)
          this.userData.visibility = res.user.visibility
          friend.showDetails = friend.showDetails ? 0 : 1
          this.$toastr(res.type, res.message, this.$t(res.type))
        }
      }).catch(console.error)
    },
    accountVisibility () {
      let data = {
        status: this.userData.visibility,
        userId: this.userData.id
      }
      this.$store.dispatch('accounts/accountVisibility', data).then((res) => {
        if (res) {
          this.$store.commit('auth/setUserData', res.user)
          this.$toastr(res.type, res.message, this.$t(res.type))
        }
      }).catch(console.error)
      this.closeModal()
    },
    closeModal () {
      this.dialog = false
      this.active = false
      this.visible = !this.visible
      this.visibleAll = !this.visibleAll
      this.dialogDelete = false
    },
    closeDeleteModal () {
      this.dialogDelete = false
    },
    closeModalFriend () {
      this.dialogFriends = false
    },
    close () {
      this.dialogConfirm = false
    },
    openRequestModal () {
      this.dialog = !this.dialog
      this.active = false
      this.visibleAll = false
      this.visible = false
    },
    openFriendsListModal () {
      this.dialogFriends = !this.dialogFriends
      this.dialog = false
      this.$store.dispatch('profile/getUserFriend', {userId: this.userData.id})
        .then(response => {
          let allFriends = []
          if (response.friends) {
            response.friends.forEach(friend => {
              allFriends.push(friend)
            })
          }
          this.allFriends = allFriends
        }).catch(err => {
          console.log(err)
        })
    },
    tiggerInputFile () {
      this.$refs.file.click()
    },
    updateUser () {
      if (this.$refs.form.validate()) {
        let showToastrMessage = false
        if (!_.isEqual(this.userData, this.stateUserData)) {
          this.$store.dispatch('profile/updateUser', this.userData).then((res) => {
            if (res) {
              if (res.user) {
                this.userData = Object.assign({}, this.userData, res.user)
                this.$store.dispatch('auth/updateUserData', {userData: JSON.parse(JSON.stringify(this.userData))})
                  .then(() => {
                  })
                  .catch((err) => {
                    console.log(err)
                  })
                this.$toastr(res.type, res.message, this.$t(res.type))
                this.$router.push(`/accounts/${this.userData.id}`)
              }
              if (res.errors) {
                res.errors.forEach((error) => {
                  this.$toastr('error', error.message, this.$t('error'))
                })
              }
            }
          }).catch(console.error)
        } else {
          showToastrMessage = true
          if (!this.croppedAvatar['blob']) {
            this.$toastr('warning', this.$t('accounts.no_any_changes'), this.$t('warning'))
          }
        }

        if (this.croppedAvatar['blob']) {
          this.uploadProfilePicture(showToastrMessage)
        }
      }
    },
    onFileChange (item, e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      if (files[0].size > 1024 * 1024 * 3) {
        this.$toastr('error', this.$t('products.image_upload_max_size'), this.$t('error'))
        this.$refs.file.value = ''
        return
      }
      this.file = files[0]

      const reader = new FileReader()
      reader.onload = (e) => {
        this.avatarImgCropSrc = e.target.result
      }
      reader.readAsDataURL(this.file)
    },
    createImage (imagePath) {
      this.userData.image = imagePath
      this.$store.dispatch('auth/updateUserData', {userData: JSON.parse(JSON.stringify(this.userData))})
        .then(() => {})
        .catch((err) => {
          console.log(err)
        })
    },
    uploadProfilePicture (showToastrMessage) {
      if (!this.croppedAvatar['blob']) {
        this.$toastr('warning', this.$t('data_updated_success'), this.$t('info'))
        return false
      }
      const formData = new FormData()
      formData.append('file', this.croppedAvatar['blob'])

      this.$store.dispatch('profile/uploadProfilePicture', formData)
        .then((res) => {
          this.createImage(res.user.image)
          if (showToastrMessage) {
            this.$toastr('success', this.$t('data_updated_success'), this.$t('success'))
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    cancelCropAvatarImg () {
      this.file = ''
      this.$refs.file.value = ''
      this.$refs.cropperAvatarImg && this.$refs.cropperAvatarImg.destroy()
      this.avatarImgCropSrc = null
      this.croppedAvatar = {}
    },
    cropAvatarImg () {
      // get image data for post processing, e.g. upload or setting image src
      const croppedCanvas = this.$refs.cropperAvatarImg && this.$refs.cropperAvatarImg.getCroppedCanvas({
        width: 900,
        height: 600
      })
      if (croppedCanvas) {
        this.avatarImg = croppedCanvas.toDataURL()
        croppedCanvas.toBlob((blob) => {
          this.croppedAvatar['blob'] = blob
        }, 'image/jpeg', 0.7)
        this.cancelCropAvatarImg()
      }
    }
  },
  beforeMount () {
    this.userData = JSON.parse(JSON.stringify(this.stateUserData))
    if (this.userData.image) {
      this.avatarImg = this.apiUrl + this.userData.image
    }
  },
  created () {
    this.$store.dispatch('auth/userInfo')
      .then((res) => {
        if (res) {
          this.userData = JSON.parse(JSON.stringify(res.user))
          if (this.userData.image) {
            this.avatarImg = this.apiUrl + this.userData.image
          }
        }
      })
      .catch(console.error)
  }
}
</script>

<style lang="scss" scoped >
  .gray {
    opacity: 0.5;
    color: grey !important;
  }
  .green {
    opacity: 0.5;
    color: green !important;
  }
  a:hover {
    color: #5964db;
  }
  @import "../../../assets/sass/desktop/myAccount.scss";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/components/MyUserAccount.vue